import React from 'react';

const ResourcesSchedulingBox = () => (
  <section style={{
    maxWidth: 1500,
    margin: '48px auto 0 auto',
    padding: '0 24px',
  }}>
    <div style={{
      background: '#fff',
      borderRadius: 28,
      border: '2px solid #bfc9d1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '19px 19px',
      gap: 32,
      flexWrap: 'wrap',
      boxShadow: '0 2px 12px rgba(0,0,0,0.03)'
    }}>
      <div style={{ flex: 1, minWidth: 260 }}>
        <h2 style={{ fontWeight: 700, fontSize: 36, marginBottom: 18, color: '#18181b' }}>
          Say Goodbye to Scheduling Chaos
        </h2>
        <p style={{ fontSize: 20, marginBottom: 32, color: '#64748b', lineHeight: 1.6 }}>
          Create rotas effortlessly by typing or uploading an Excel file — our AI handles the rest with precision.
        </p>
        <a
          href="#"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: '#0098d0',
            color: '#fff',
            fontWeight: 500,
            fontSize: 20,
            borderRadius: 16,
            padding: '18px 48px',
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            transition: 'background 0.2s, color 0.2s'
          }}
        >
          Try Now
          <svg style={{ marginLeft: 12 }} width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
      <div style={{ flex: 1.2, minWidth: 320, display: 'flex', justifyContent: 'flex-end' }}>
        <img
          src="/images/HomeChased.png"
          alt="Genix Roata Dashboard"
          style={{ width: 600, height: 350, objectFit: 'contain', borderRadius: 24, border: '1px solid #bfc9d1', background: '#fff' }}
        />
      </div>
    </div>
  </section>
);

export default ResourcesSchedulingBox; 